module.exports = function() {

    /**
     * Helper
     */
    var helper = require('../../helper');

    var moment = require('moment');

    requestViewing();

    function requestViewing(){

        var $requestViewingModal = $('#available-space-request-viewing-ajax');

        $(document).on('click', '.js-request-viewing-ajax', function(e){

            e.preventDefault();
            $requestViewingModal.find('tbody').html('');

            var $this = $(this),
                propertyId = $this.data('property');


            $.ajax(
                {
                    type: 'POST',
                    url: helper.getOrigin() + '/api/property_viewings/property/'+propertyId+'/request-viewing',
                    data:  propertyId,

                    success: function(data) {
                        var $tbody = $requestViewingModal.find('tbody');
                        $tbody.html(data);

                        console.log($tbody);
                        console.log(data);

                        $requestViewingModal.modal('show');
                    },

                    error: function(data) {
                        console.log('Something went wrong');
                    }
                });

        });

    }

}();
